import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'sv';
    document.title = 'PILATES KLAR™ – Färdiga pilatesklasser för instruktörer';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk85gw6ag7ch">
      <div lang="sv" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6jhwnqi0fz">
        <CountdownBar data-id="element-2" data-mp="3recc1ebn6dd1" />
        <main data-id="element-3" data-mp="5or2zhbcs60">
          <Hero data-id="element-4" data-mp="67znpl2q47d" />
          <StatsBar data-id="element-5" data-mp="4n4bxqxqh8g" />
          <Difference data-id="element-6" data-mp="56n1goet9nj" />
          <Recognize data-id="element-7" data-mp="7sxbo2oq39g" />
          <WhatsInside data-id="element-8" data-mp="2zlle8zeb8glo" />
          <InsidePages data-id="element-9" data-mp="2zm4v0cs84yy4" />
          <Bonuses data-id="element-10" data-mp="2zmwguvw0rib7" />
          <HowItWorks data-id="element-11" data-mp="2zng2amkvootz" />
          <Audience data-id="element-12" data-mp="33m5b01uz1i7a" />
          <Offer data-id="element-13" data-mp="33nq4rp9gox43" />
          <Guarantee data-id="element-14" data-mp="33n6y54p9hv5d" />
          <Testimonials data-id="element-15" data-mp="33orla998ybt7" />
          <Faq data-id="element-16" data-mp="38m1e7yvuh5ls" />
          <FinalCta data-id="element-17" data-mp="38li8dgjgy7o4" />
        </main>
        <Footer data-id="element-18" data-mp="38kgl8dp6huq1" />
      </div>
    </MotionConfig>;
}